module.exports = __webpack_public_path__ + "../resources/img/weather_partly-cloudy-night.b8172bf4.svg";